<template>
     <div class="conf-con">
                            <div class="intro-pic">
                                <img src="../../../assets/images/11.gif" alt="">
                            </div>
                            <p class="intro-tit">中国共产党第十一次全国代表大会简介</p>
                            <p class="margin1">1977年8月12日至18日在北京举行。应到大会的代表1510人，除刘伯承等8位同志因病因事请假未能出席预备会议外，实际出席会议代表1502名。代表全国党员3500多万。华国锋作政治报告，叶剑英作《关于修改党的章程的报告》，邓小平致闭幕词。大会宣告历时10年的“文化大革命”已经结束，重申建设社会主义的现代化强国的任务，但没有能纠正“文化大革命”的“左”倾错误理论、政策和口号。大会通过了经过修改的《中国共产党章程》和《关于政治报告的决议》、《关于修改党的章程报告的决议》。大会选举了由201名委员和132名候补委员组成的中央委员会。随后召开的十一届一中全会选举了中央政治局及其常务委员会，选举华国锋为中央委员会主席，叶剑英、邓小平、李先念、汪东兴为副主席。</p>
                        </div>
  </template>
  
  <script>
  export default {
  
  }
  </script>
  
  <style>
  
  </style>